import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CustomLayoutComponent } from './custom-layout/custom-layout.component';
import { VexRoutes } from '../@vex/interfaces/vex-route.interface';
import { QuicklinkModule, QuicklinkStrategy } from 'ngx-quicklink';
import { AuthGuard } from './pages/shared/guards/auth.guard';

const routes: VexRoutes = [
  {
    path: '',
    loadChildren: () => import('./pages/security/auth/login/login.module').then(m => m.LoginModule),
  },
  {
    path: 'register',
    loadChildren: () => import('./pages/security/auth/register/register.module').then(m => m.RegisterModule),
  },
  {
    path: 'forgot-password',
    loadChildren: () => import('./pages/security/auth/forgot-password/forgot-password.module').then(m => m.ForgotPasswordModule),
  },
  {
    path: 'coming-soon',
    loadChildren: () => import('./pages/pages/coming-soon/coming-soon.module').then(m => m.ComingSoonModule),
  },
  {
    path: 'monitoring',
    component: CustomLayoutComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    children: [
      {
        path: 'monitoring/analytics',
        redirectTo: 'monitoring'
      },
      {
        path: 'analytics',
        loadChildren: () => import('./pages/dashboards/dashboard-analytics/dashboard-analytics.module').then(m => m.DashboardAnalyticsModule),
      },
      {
        path: 'system-resources',
        children: [
          {
            path: 'cpu',
            loadChildren: () => import('./pages/system-resources/cpu-performance/cpu-performance.module').then(m => m.CpuPerformanceModule),
            data: {
              toolbarShadowEnabled: true
            }
          },
          {
            path: 'disk-space/:resource',
            loadChildren: () => import('./pages/system-resources/disk-space/disk-space.module').then(m => m.DiskSpaceModule),
            data: {
              toolbarShadowEnabled: true
            }
          }
        ]
      },      
      {
        path: 'application-performance',
        children: [
          {
            path: 'app-servers',
            loadChildren: () => import('./pages/application-performance/app-servers/app-servers.module').then(m => m.AppServersModule),
            data: {
              toolbarShadowEnabled: true
            }
          },
          {
            path: 'batch-jobs',
            loadChildren: () => import('./pages/application-performance/batch-jobs/batch-jobs.module').then(m => m.BatchJobsModule),
            data: {
              toolbarShadowEnabled: true
            }
          },
          {
            path: 'communication',
            loadChildren: () => import('./pages/application-performance/communication/communication.module').then(m => m.CommunicationModule),
            data: {
              toolbarShadowEnabled: true
            }
          }
        ]
      },
      {
        path: 'cdc-prosql',
        children: [
          {
            path: 'summary',
            loadChildren: () => import('./pages/cdc-prosql/cdc-prosql-db/cdc-prosql.module').then(m => m.CdcProsqlModule),
            data: {
              toolbarShadowEnabled: true
            }
          }
        ]
      },
      {
        path: '**',
        loadChildren: () => import('./pages/pages/errors/error-404/error-404.module').then(m => m.Error404Module)
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    preloadingStrategy: QuicklinkStrategy,
    scrollPositionRestoration: 'enabled',
    relativeLinkResolution: 'corrected',
    anchorScrolling: 'enabled'
  })],
  exports: [RouterModule, QuicklinkModule]
})
export class AppRoutingModule {
}
